import { render, staticRenderFns } from "./_list.vue?vue&type=template&id=40b68b7b"
import script from "./_list.vue?vue&type=script&lang=js"
export * from "./_list.vue?vue&type=script&lang=js"
import style0 from "./_list.vue?vue&type=style&index=0&id=40b68b7b&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports